import { Component, Input } from '@angular/core';
import { HelperServiceService } from '../../../../../utils/helper-service.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-document-form',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './document-form.component.html',
  styleUrl: './document-form.component.css'
})
export class DocumentFormComponent {
    @Input() chapterId: string = ''
    @Input() topicId: string = ''
    @Input() subTopicId: string = ''
    @Input() documentId: string = ''

  thumbnail: File | null = null;
  thumbnailUrl: string | ArrayBuffer | null = null;

  isPreview:boolean = true

  constructor(private helperService: HelperServiceService) { }
  onFileSelected(e: Event): void {
    this.helperService.getImageWithAspectCheck(e, 'video').then(({ image, imageUrl }) => {
      if (image) {
        this.thumbnail = image;
        this.thumbnailUrl = imageUrl;
      }
    })
  }
}

